import ApiService from '../api.service';
import { LocaleService } from '../storage.service';

export default {
    async getObjectsHouses(itemsPerPage, currentItem, iWhereOrderLocale) {
        const { data: response } = await ApiService.post('prescription/getObjectsHouses', { itemsPerPage, currentItem, iWhereOrderLocale });
        return response.data;
    },
    async getPrescriptions(itemsPerPage, currentItem, iWhereOrderLocale) {
        const { data: response } = await ApiService.post('prescription/getPrescriptions', { itemsPerPage, currentItem, iWhereOrderLocale });
        return response.data;
    },
    async getEventTypes() {
        const { data: response } = await ApiService.get('prescription/getEventTypes');
        return response.data;
    },
    async postPrescriptions(nvcPrescriptionData) {
        const { data: response } = await ApiService.post('prescription/postPrescriptions', { nvcPrescriptionData });
        return response.data;
    },
    async getPrescriptionInfo(iPrescription_rid) {
        const { data: response } = await ApiService.post('prescription/getPrescriptionInfo', { iPrescription_rid });
        return response.data;
    },
    async prescriptionStatusChange(iPrescription_rid, iStatus_rid) {
        const { data: response } = await ApiService.get('prescription/prescriptionStatusChange', {
            params: {
                iPrescription_rid,
                iStatus_rid
            }
        });
        return response.data;
    },
    async prescriptionStatusTypes() {
        const { data: response } = await ApiService.get('prescription/prescriptionStatusTypes');
        return response.data;
    },
    async getEngineerKSKHousesList(iengineer_rid) {
        const { data: response } = await ApiService.get('prescription/getEngineerKSKHousesList', {
            params: {
                iengineer_rid
            }
        });
        return response.data;
    },
    async getEngineerContractsList(iengineer_rid) {
        const { data: response } = await ApiService.get('prescription/getEngineerContractsList', {
            params: {
                iengineer_rid
            }
        });
        return response.data;
    },
    async engineerObjectContractsList(icontract_rid, iengineer_rid) {
        const { data: response } = await ApiService.get('prescription/engineerObjectContractsList', {
            params: {
                icontract_rid,
                iengineer_rid
            }
        });
        return response.data;
    }
};
